import Vue from 'vue'
import App from './App.vue'

import 'bulma/css/bulma.css'

new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js